import React, { useState, useEffect, Fragment } from 'react';
import { validateProperty, validate } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi';
import { duplicateTagValidationSchemaObject } from '../duplicateTagValidationSchema';
import services from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import { CardHeader, Box, Chip } from '@material-ui/core';

const screenCode = 'DUPLICATETAGVERIFICATION';

export function DuplicateTagVerificationAddEdit(props) {
    const { data, edit } = props.location;
    const [title, setTitle] = useState("Duplicate Tag Renewal");
    const [buttonName, setButtonName] = useState("Save");
    const [isChanged, setIsChanged] = useState(0);
    const [duplicateTagData, setDuplicateTagData] = useState({
        productCollectionID: '0',
        actualAmount: '0',
        grossAmount: '0',
        netAmount: '0',
        tagNumber: '',
        weightReadTime: '',
        totalDeduction: '',
        weightReadGPS: '',
        tagReadGPS: '',
        tagReadTime: '',
        edit: props.location.edit !== undefined
    });

    const [errors, setErrors] = useState({});
    const [fieldDeductions,setFieldDeductions]=useState([]);
    const [factoryDeductions,setFactoryDeductions]=useState([]);
    const [deductionList,setDeductionList]=useState([]);
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });

    const schema = Joi.object(duplicateTagValidationSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise( manageFieldDeductions());
        trackPromise( manageFactoryDeductions());
    }, [factoryDeductions,fieldDeductions]);

    useEffect(() => {
        setIsChanged(isChanged + 1);
    }, [duplicateTagData]);

    useEffect(() => {
       trackPromise( manageFieldDeductions());
       
    }, [data.productCollectionDetailsID]);

    useEffect(() => {
       trackPromise( manageFactoryDeductions());
    }, [data.factoryWeighDetailID]);

    async function getDeductions(){
        const deductions=await services.getAllDeductions(data.groupID,data.operationEntityID,data.collectionPointID);
        setDeductionList(deductions);
        return deductions;
    }

    async function manageFactoryDeductions(){
         const deductions= await getDeductions();
         var sampleFactoryDeductions=factoryDeductions;
        JSON.parse(data.deductions).forEach(element => {
            deductions.forEach(item=>{
               
                if(parseInt(item.deductionTemplateID)===parseInt(element.DeductionTemplateID)){
                    sampleFactoryDeductions.push({deductionAmount:element.DeductionAmount,deductionTypeName:item.deductionTypeName,deductionTypeID:item.deductionTypeID});
                }
            });
        });
        setFactoryDeductions(sampleFactoryDeductions); 
    }

    async function manageFieldDeductions(){
        const deductions= await getDeductions();
        var sampleFieldDeductions=fieldDeductions;
       JSON.parse(data.factoryWeighDeductions).forEach(element => {
           deductions.forEach(item=>{
               if(parseInt(item.deductionTemplateID)===parseInt(element.DeductionTemplateID)){
                   sampleFieldDeductions.push({deductionAmount:element.DeductionAmount,deductionTypeName:item.deductionTypeName,deductionTypeID:item.deductionTypeID});
               }
           });
       });
       setFieldDeductions(sampleFieldDeductions);
   }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITTAGVERIFICATION');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        setButtonName("Update");
        setTitle("Edit Duplicate Tag");
        setDuplicateTagEditData();
    }

    function setDuplicateTagEditData() {

        setDuplicateTagData({
            ...duplicateTagData,
            tagNumber: data.tagNumber.toString(),
            grossAmount: data.grossAmount.toString(),
            netAmount: data.netAmount.toString(),
            totalDeduction: data.totalDeduction,
            actualAmount: data.actualAmount.toString(),
            tagReadGPS: data.tagReadGPS,
            weightReadGPS: data.weightReadGPS,
            factoryActualAmount:data.factoryActualAmount,
            factoryGrossAmount:data.factoryGrossAmount,
            factoryNetAmount:data.factoryNetAmount,
            factoryTagReadGPS:data.factoryTagReadGPS,
            factoryTagReadTime:data.factoryTagReadTime,
            factoryTotalDeduction:data.factoryTotalDeduction,
            factoryWeightReadGPS:data.factoryWeightReadGPS,
            factoryWeightReadTime:data.factoryWeightReadTime,
            mobileSessionID:data.mobileSessionID,
            factoryWeighDetailID:data.factoryWeighDetailID,
        });
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        const error = { ...errors };
        const errorMessage = validateProperty(target, duplicateTagValidationSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setDuplicateTagData({
            ...duplicateTagData,
            [e.target.name]: value
        });
        setErrors(error);
    }

    async function handleEdit(e) {
        let factoryWeighModel={
            factoryActualAmount:data.factoryActualAmount,
            factoryGrossAmount:data.factoryGrossAmount,
            factoryNetAmount:data.factoryNetAmount,
            factoryTagReadGPS:data.factoryTagReadGPS,
            factoryTagReadTime:data.factoryTagReadTime,
            factoryTotalDeduction:data.factoryTotalDeduction,
            factoryWeightReadGPS:data.factoryWeightReadGPS,
            factoryWeightReadTime:data.factoryWeightReadTime,
            factoryWeighDetailID:data.factoryWeighDetailID,
            mobileSessionID:data.mobileSessionID,
            collectionPointID:parseInt(data.collectionPointID),
            groupID:parseInt(data.groupID),
            operationEntityID:parseInt(data.operationEntityID)
        }
        e.preventDefault();
        let updateModel = {
            ProductDeduction: JSON.parse(data.deductions),
            productCollectionID: data.productCollectionID,
            productCollectionDetailsID: data.productCollectionDetailsID,
            actualAmount: data.actualAmount,
            grossAmount: data.grossAmount,
            netAmount: data.netAmount,
            tagNumber: duplicateTagData.tagNumber,
            weightReadTime: data.weightReadTime,
            totalDeduction: data.totalDeduction,
            weightReadGPS: data.weightReadGPS,
            tagReadGPS: data.tagReadGPS,
            tagReadTime: data.tagReadTime,
            productCollectionDetailsDuplicateID: data.productCollectionDetailsDuplicateID,
            factoryWeighDetail:factoryWeighModel,
            factoryWeighDeductions: JSON.parse(data.factoryWeighDeductions),
            factoryExceptionID: data.factoryExceptionID,
        }
        const response = await services.editDuplicateData(updateModel);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
        afterSuccessfulyChanged(response.statusCode);

    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState();
            setTimeout(() => {
                props.history.push({ pathname: '/duplicateTagVerification' });
            }, 1500);
        }
    }

    function clearState() {
        setDuplicateTagData({
            ...duplicateTagData,
            productCollectionID: '0',
            actualAmount: '0',
            grossAmount: '0',
            netAmount: '0',
            tagNumber: '',
            weightReadTime: '',
            totalDeduction: '',
            weightReadGPS: '',
            tagReadGPS: '',
            tagReadTime: '',
        });
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    buttonText="Back to Listing"
                                    path="/duplicateTagVerification"
                                    isChanged={isChanged}
                                    clearPage={clearState}
                                />
                            </div>
                            <hr />
                            <form onSubmit={(e) => trackPromise(handleEdit(e))} disabled={false}>

                                <div className="card">
                                    <Box border={2} borderRadius={16} borderColor="#43A047">
                                        <CardHeader style={{ color: '#43A047', textAlign: 'center' }} titleTypographyProps={{ variant: 'h6' }} title="Tag Details" />
                                        <div className="card-body"  >
                                            <div className="row row-top-gap" style={{display: "flex",justifyContent: "center",alignItems: "center"
                                            }}>
                                                <div className="col-md-6" >
                                                    <InputLabel style={{textAlign:'center'}} shrink id="tagNumber">Tag Number *</InputLabel>
                                                    <TextField
                                                        fullWidth
                                                        labelId="tagNumber"
                                                        id="tagNumber"
                                                        name="tagNumber"
                                                        value={duplicateTagData.tagNumber}
                                                        onChange={(e) => handleChange(e)}
                                                        InputProps={{ style: { fontSize: 30, fontStyle: "initial",textAlign:'center',cursor:'none'}, disableUnderline: true }}
                                                    />
                                                    {errors["tagNumber"] && <FormHelperText error>{errors["tagNumber"]}</FormHelperText>}
                                                </div>
                                            </div>
                                        </div>
                                    </Box>
                                </div>
                                <div className="row" >
                                    <div className="col-md-6">
                                        <CardHeader style={{ color: '#43A047', textAlign: 'center' }} titleTypographyProps={{ variant: 'h6' }} title="Field Details" />
                                        <div className="card" style={{ border: '1rem', borderColor: 'red' }}>
                                            <Box border={2} borderRadius={0} borderColor="#43A047">
                                                <CardHeader style={{ color: '#43A047', textAlign: 'center' }} titleTypographyProps={{ variant: 'h7' }} title="Amount Details" />
                                                <div className="card-body">
                                                    <div className="row row-top-gap">
                                                        <div className="col-md-3 pb-1">
                                                            <InputLabel shrink id="grossAmount">Gross Amount</InputLabel>
                                                            <TextField
                                                                fullWidth
                                                                labelId="grossAmount"
                                                                id="grossAmount"
                                                                name="grossAmount"
                                                                value={duplicateTagData.grossAmount}
                                                                onChange={(e) => handleChange(e)}
                                                                disabled={true}
                                                                InputProps={{ disableUnderline: true }}
                                                            />
                                                            {errors["grossAmount"] && <FormHelperText error>{errors["grossAmount"]}</FormHelperText>}
                                                        </div>
                                                        <div className="col-md-3 pb-1">
                                                            <InputLabel shrink id="netAmount">Net Amount</InputLabel>
                                                            <TextField
                                                                fullWidth
                                                                labelId="netAmount"
                                                                id="netAmount"
                                                                name="netAmount"
                                                                value={duplicateTagData.netAmount}
                                                                onChange={(e) => handleChange(e)}
                                                                disabled={true}
                                                                InputProps={{ disableUnderline: true }}
                                                            />
                                                            {errors["netAmount"] && <FormHelperText error>{errors["netAmount"]}</FormHelperText>}
                                                        </div>

                                                        <div className="col-md-3 pb-1">
                                                            <InputLabel shrink id="actualAmount">Actual Amount</InputLabel>
                                                            <TextField
                                                                fullWidth
                                                                labelId="actualAmount"
                                                                id="actualAmount"
                                                                name="actualAmount"
                                                                value={duplicateTagData.actualAmount}
                                                                onChange={(e) => handleChange(e)}
                                                                disabled={true}
                                                                InputProps={{ disableUnderline: true }}
                                                            />
                                                            {errors["actualAmount"] && <FormHelperText error>{errors["actualAmount"]}</FormHelperText>}
                                                        </div>
                                                        <div className="col-md-3 pb-1">
                                                            <InputLabel shrink id="totalDeduction">Total Deduction</InputLabel>
                                                            <TextField
                                                                fullWidth
                                                                labelId="totalDeduction"
                                                                id="totalDeduction"
                                                                name="totalDeduction"
                                                                value={duplicateTagData.totalDeduction}
                                                                onChange={(e) => handleChange(e)}
                                                                disabled={true}
                                                                InputProps={{ disableUnderline: true }}
                                                            />
                                                            {errors["totalDeduction"] && <FormHelperText error>{errors["totalDeduction"]}</FormHelperText>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Box>
                                        </div>
                                        <div className="card">
                                            <Box border={2} borderRadius={0} borderColor="#43A047">
                                                <CardHeader style={{ color: '#43A047', fontVariant: 'bold', textAlign: 'center' }} titleTypographyProps={{ variant: 'h7' }} title="GPS Details" />
                                                <div className="card-body">
                                                    <div className="row row-top-gap">
                                                        <div className="col">
                                                            <InputLabel shrink id="tagReadGPS">Tag Read GPS</InputLabel>
                                                            <TextField
                                                                fullWidth
                                                                labelId="tagReadGPS"
                                                                id="tagReadGPS"
                                                                name="tagReadGPS"
                                                                value={duplicateTagData.tagReadGPS}
                                                                onChange={(e) => handleChange(e)}
                                                                disabled={true}
                                                                InputProps={{ disableUnderline: true }}
                                                            />
                                                            {errors["tagReadGPS"] && <FormHelperText error>{errors["tagReadGPS"]}</FormHelperText>}
                                                        </div>
                                                        <div className="col">
                                                            <InputLabel shrink id="weightReadGPS">Weight Read GPS</InputLabel>
                                                            <TextField
                                                                fullWidth
                                                                labelId="weightReadGPS"
                                                                id="weightReadGPS"
                                                                name="weightReadGPS"
                                                                value={duplicateTagData.weightReadGPS}
                                                                onChange={(e) => handleChange(e)}
                                                                disabled={true}
                                                                InputProps={{ disableUnderline: true }}
                                                            />
                                                            {errors["weightReadGPS"] && <FormHelperText error>{errors["weightReadGPS"]}</FormHelperText>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Box>
                                        </div>

                                        <div className="card">
                                            <Box border={2} borderRadius={0} borderColor="#43A047">
                                                <CardHeader style={{ color: '#43A047', fontVariant: 'bold', textAlign: 'center' }} titleTypographyProps={{ variant: 'h7' }} title="Deduction Details" />
                                                <div className="card-body">
                                                    <div className="row row-top-gap">
                                                        <div className="col" style={{display: 'flex'}}>
                                                        {fieldDeductions.map((data) => {
                                                                return (
                                                                    <li key={data.deductionTypeID} style={{listStyle:'none',marginRight:'0.5rem'}}>
                                                                        <Chip
                                                                            label={data.deductionTypeName + ":" + data.deductionAmount}
                                                                        />
                                                                    </li>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Box>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <CardHeader style={{ color: '#43A047', textAlign: 'center' }} titleTypographyProps={{ variant: 'h6' }} title="Factory Details" />
                                        <div className="card" style={{ border: '1rem', borderColor: 'red' }}>
                                            <Box border={2} borderRadius={0} borderColor="#43A047">
                                                <CardHeader style={{ color: '#43A047', textAlign: 'center' }} titleTypographyProps={{ variant: 'h7' }} title="Amount Details" />
                                                <div className="card-body">
                                                    <div className="row row-top-gap">
                                                        <div className="col-md-3 pb-1">
                                                            <InputLabel shrink id="factoryGrossAmount">Gross Amount</InputLabel>
                                                            <TextField
                                                                fullWidth
                                                                labelId="factoryGrossAmount"
                                                                id="factoryGrossAmount"
                                                                name="factoryGrossAmount"
                                                                value={duplicateTagData.factoryGrossAmount}
                                                                onChange={(e) => handleChange(e)}
                                                                disabled={true}
                                                                InputProps={{ disableUnderline: true }}
                                                            />
                                                            {errors["factoryGrossAmount"] && <FormHelperText error>{errors["factoryGrossAmount"]}</FormHelperText>}
                                                        </div>
                                                        <div className="col-md-3 pb-1">
                                                            <InputLabel shrink id="factoryNetAmount">Net Amount</InputLabel>
                                                            <TextField
                                                                fullWidth
                                                                labelId="factoryNetAmount"
                                                                id="factoryNetAmount"
                                                                name="factoryNetAmount"
                                                                value={duplicateTagData.factoryNetAmount}
                                                                onChange={(e) => handleChange(e)}
                                                                disabled={true}
                                                                InputProps={{ disableUnderline: true }}
                                                            />
                                                            {errors["factoryNetAmount"] && <FormHelperText error>{errors["factoryNetAmount"]}</FormHelperText>}
                                                        </div>

                                                        <div className="col-md-3 pb-1">
                                                            <InputLabel shrink id="factoryActualAmount">Actual Amount</InputLabel>
                                                            <TextField
                                                                fullWidth
                                                                labelId="factoryActualAmount"
                                                                id="factoryActualAmount"
                                                                name="factoryActualAmount"
                                                                value={duplicateTagData.factoryActualAmount}
                                                                onChange={(e) => handleChange(e)}
                                                                disabled={true}
                                                                InputProps={{ disableUnderline: true }}
                                                            />
                                                            {errors["factoryActualAmount"] && <FormHelperText error>{errors["factoryActualAmount"]}</FormHelperText>}
                                                        </div>
                                                        <div className="col-md-3 pb-1">
                                                            <InputLabel shrink id="factoryTotalDeduction">Total Deduction</InputLabel>
                                                            <TextField
                                                                fullWidth
                                                                labelId="factoryTotalDeduction"
                                                                id="factoryTotalDeduction"
                                                                name="factoryTotalDeduction"
                                                                value={duplicateTagData.factoryTotalDeduction}
                                                                onChange={(e) => handleChange(e)}
                                                                disabled={true}
                                                                InputProps={{ disableUnderline: true }}
                                                            />
                                                            {errors["factoryTotalDeduction"] && <FormHelperText error>{errors["factoryTotalDeduction"]}</FormHelperText>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Box>
                                        </div>
                                        <div className="card">
                                            <Box border={2} borderRadius={0} borderColor="#43A047">
                                                <CardHeader style={{ color: '#43A047', fontVariant: 'bold', textAlign: 'center' }} titleTypographyProps={{ variant: 'h7' }} title="GPS Details" />
                                                <div className="card-body">
                                                    <div className="row row-top-gap">
                                                        <div className="col">
                                                            <InputLabel shrink id="factoryTagReadGPS">Tag Read GPS</InputLabel>
                                                            <TextField
                                                                fullWidth
                                                                labelId="factoryTagReadGPS"
                                                                id="factoryTagReadGPS"
                                                                name="factoryTagReadGPS"
                                                                value={duplicateTagData.factoryTagReadGPS}
                                                                onChange={(e) => handleChange(e)}
                                                                disabled={true}
                                                                InputProps={{ disableUnderline: true }}
                                                            />
                                                            {errors["factoryTagReadGPS"] && <FormHelperText error>{errors["factoryTagReadGPS"]}</FormHelperText>}
                                                        </div>
                                                        <div className="col">
                                                            <InputLabel shrink id="factoryWeightReadGPS">Weight Read GPS</InputLabel>
                                                            <TextField
                                                                fullWidth
                                                                labelId="factoryWeightReadGPS"
                                                                id="factoryWeightReadGPS"
                                                                name="factoryWeightReadGPS"
                                                                value={duplicateTagData.factoryWeightReadGPS}
                                                                onChange={(e) => handleChange(e)}
                                                                disabled={true}
                                                                InputProps={{ disableUnderline: true }}
                                                            />
                                                            {errors["factoryWeightReadGPS"] && <FormHelperText error>{errors["factoryWeightReadGPS"]}</FormHelperText>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Box>
                                        </div>
                                        <div className="card">
                                            <Box border={2} borderRadius={0} borderColor="#43A047">
                                                <CardHeader style={{ color: '#43A047', fontVariant: 'bold', textAlign: 'center' }} titleTypographyProps={{ variant: 'h7' }} title="Deduction Details" />
                                                <div className="card-body">
                                                    <div className="row row-top-gap">
                                                        <div className="col" style={{display: 'flex'}}>
                                                        {factoryDeductions.map((data) => {
                                                                return (
                                                                    <li key={data.deductionTypeID}  style={{listStyle:'none',marginRight:'0.5rem'}}>
                                                                        <Chip
                                                                            label={data.deductionTypeName + ":" + data.deductionAmount}
                                                                        />
                                                                    </li>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Box>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, duplicateTagData)}
                                        type="submit"
                                        className="btn btn-primary"
                                        value={buttonName}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}